const SDK_VERSION = "10.75.1" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
